import React from 'react';
import './MeetAstrologer.css';

const MeetAstrologer = () => {
  return (
    <section id="about" className="meet-astrologer">
      <div className="astrologer-container">
        <div className="astrologer-content">
          <div className="astrologer-header">
            <h2 className="astrologer-title">Meet Astrologer Saahil Kohli</h2>
            <p className="astrologer-subtitle">Founder & Vedic Expert</p>
          </div>
          <div className="astrologer-body">
            <div className="astrologer-image-wrapper">
              <img 
                src="/saahil-kohli.png" 
                alt="Saahil Kohli - Founder & Vedic Expert"
                className="astrologer-image"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="astrologer-image-placeholder" style={{display: 'none'}}>
                <span>Saahil Kohli</span>
              </div>
            </div>
            <div className="astrologer-info">
              <p className="astrologer-description">
                Founder of AstroIndia, followed by millions across YouTube, Instagram, and Facebook. 
                Known for simple, practical, and accurate Vedic astrology explanations. 
                Saahil brings ancient wisdom to modern life problems.
              </p>
              <a
                href="https://www.youtube.com/@AstroIndia666"
                target="_blank"
                rel="noopener noreferrer"
                className="youtube-button"
              >
                <span className="youtube-icon">▶</span>
                Subscribe on YouTube
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MeetAstrologer;

